import React, { useEffect, useState } from 'react';
import OrderPrint from '../../components/factoryOrder/OrderPrint';
import DeleteModal from "../../components/common/DeleteModal";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import { CreateEntry, DeleteEntry, UpdateEntry } from "../../providers/dataProvider";
import FactoryOrderProductList from './FactoryOrderProductList';
import FactoryOrderProductSummary from './FactoryOrderProductSummary';
import FactoryOrderQuantityEntry from '../../components/factoryOrder/FactoryorderQuantityEntry/FactoryOrderQuantityEntry';

const FactoryOrderProduct = ({
    menuRights,
    values,
    currencyDetail,
    setValues,
    currencyList,
    setQuotUserEntry,
    quotUserEntry,
    handleSubmit,
    loading,
    orderProductTab,
    setOrderProductTab,
    factoryReleaseRecordId,
    refreshFactoryOrderData,
    refreshFactoryOrderMarkData,
    activeMainTab,
    factoryOrderRecord,
    selectedOrder,
    releaseForm,
    isFactoryOrderEditMode,
    handleDeliveryFromDateChange
}) => {
    const [orderProductCount, setOrderProductCount] = useState(0);
    const [rename, setRename] = useState(null);
    const [renameError, setRenameError] = useState(null);
    const [deleteShow, setDeleteShow] = useState({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false
    });
    const [actionMsg, setActionMsg] = useState(null);
    const [productionMsg, setProductionMsg] = useState(null);
    const [productionShow, setProductionShow] = useState(false);
    const [productionLoading, setProductionLoading] = useState(false);

    const EditOrderQuantity = (item) => {
        setOrderProductTab({ tab: "editorderquantity", data: item });
    };

    const getOrderProductId = (item) => item?.orderProductId || item?.id;

    const updateProducts = (updater) => {
        setValues((prev) => ({
            ...prev,
            products: updater(prev?.products || []),
        }));
    };

    const getProductKeys = (item) => [
        item?.customerOrderProductId,
        item?.quoteProductId,
        item?.orderProductId,
        item?.id,
    ].filter((value) => value !== null && value !== undefined && value !== "");

    const isSameProduct = (left, right) =>
        getProductKeys(left).some((leftKey) =>
            getProductKeys(right).some((rightKey) => String(leftKey) === String(rightKey))
        );

    const handleProductDeliveryDateChange = (date, product) => {
        updateProducts((products) =>
            products.map((item) =>
                isSameProduct(item, product)
                    ? { ...item, requestedDeliveryDate: date }
                    : item
            )
        );
    };

    const ProductRename = (item) => {
        if (!getOrderProductId(item)) return;
        setRename({ ...item });
        setRenameError(null);
    };

    const updateMarkName = () => {
        if (!rename) return;
        const markName = rename?.markName?.trim();
        if (!markName) {
            setRenameError("Name is required");
            return;
        }

        const orderProductId = getOrderProductId(rename);
        const updatedProduct = { ...rename, id: orderProductId, markName };
        setRenameError(null);
        updateProducts((products) =>
            products.map((product) =>
                getOrderProductId(product) === orderProductId
                    ? { ...product, markName }
                    : product
            )
        );
        UpdateEntry(
            "updateorderproductmark",
            updatedProduct,
            setActionMsg,
            "Mark Name updated successfully",
            "Failed to update markName"
        );
        setRename(null);
    };

    const HandleRenameKeyDown = (event) => {
        if (event.key === "Enter") updateMarkName();
    };

    const factoryReleaseId = factoryReleaseRecordId || factoryOrderRecord?.id;

    const handleGenerateProduction = () => {
        if (!factoryReleaseId) return;

        setProductionLoading(true);
        CreateEntry(
            "factoryrelease",
            { factoryReleaseId },
            setProductionMsg,
            "Production batch generated successfully",
            "Failed to generate production batch"
        );
    };

    useEffect(() => {
        if (actionMsg?.message === "Mark duplicated successfully" && actionMsg?.successData?.id) {
            const duplicateId = actionMsg.successData.id;
            updateProducts((products) =>
                products.map((product, index) =>
                    typeof product?.id === "string" && product.id.indexOf("copy-") === 0 && index === products.length - 1
                        ? { ...actionMsg.successData, id: duplicateId }
                        : product
                )
            );
        }
    }, [actionMsg]);

    useEffect(() => {
        if (!productionMsg) return;

        const statusCode = productionMsg?.statusCode ?? productionMsg?.status;
        const isSuccess = statusCode === 200 || statusCode === 201 || statusCode === 204;

        setProductionLoading(false);
        if (isSuccess) {
            setProductionShow(true);
        }
    }, [productionMsg]);

    return (
        <div
            className={`tab-pane fade${activeMainTab === "order-summary" ? " show active" : ""}`}
            id="pills-order-summary"
            role="tabpanel"
            aria-labelledby="pills-order-summary-tab"
        >
            {orderProductTab.tab === "editorderquantity" ? (
               <FactoryOrderQuantityEntry
                        setOrderProductTab={setOrderProductTab}
                        values={values}
                        setValues={setValues}
                        orderProductTab={orderProductTab}
                        currencyDetail={currencyDetail}
                        factoryReleaseRecordId={factoryReleaseRecordId}
                        refreshFactoryOrderMarkData={refreshFactoryOrderMarkData}
                        refreshFactoryOrderData={refreshFactoryOrderData}
                        factoryOrderRecord={factoryOrderRecord}
                        releaseForm={releaseForm}
                        isFactoryOrderEditMode={isFactoryOrderEditMode}
                    />
            ) : (
                <>
                    <div className="row pt-1 product-configurations-row mt-2 order-product-manage">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="quote-product-actionbar order-product-actionbar">
                                <div>
                                    <span>Products</span>
                                    <strong>{orderProductCount} mark{orderProductCount === 1 ? "" : "s"}</strong>
                                </div>
                                <div className="d-flex">
                                    {factoryOrderRecord?.isLockedForEdit ? (
                                    <div className="factory-order-btn">
                                        Factory order released
                                    </div>
                                    ) : (
                                    <div className="quote-product-actionbar-actions">
                                        {factoryReleaseId ? (
                                            <button
                                                type="button"
                                                className="btn update-btn"
                                                onClick={handleGenerateProduction}
                                                disabled={productionLoading}
                                                style={{color: '#fff', background: '#005795', borderColor: '#005795', height: '31px',borderRadius:'7px', padding: '3px', fontSize: '14px', width: '80px',marginRight:'7px'}}
                                            >
                                                {productionLoading ? "Generating..." : "Release"}
                                            </button>
                                        ) : null}
                                    </div>
                                    )}
                                    <div className="quote-product-actionbar-actions">
                                        {menuRights?.canPrint === true && (
                                            <OrderPrint
                                                values={{ ...values, id: factoryReleaseId, orderId: values?.id }}
                                                currencyDetail={currencyDetail}
                                            />                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="row quotation-summary-row order-summary-products-row">
                                <FactoryOrderProductList
                                    values={values}
                                    currencyDetail={currencyDetail}
                                    EditOrderQuantity={EditOrderQuantity}
                                    rename={rename}
                                    renameError={renameError}
                                    setOrderProductCount={setOrderProductCount}
                                    onRename={ProductRename}
                                    onRenameBlur={updateMarkName}
                                    onRenameChange={setRename}
                                    onRenameKeyDown={HandleRenameKeyDown}
                                    factoryOrderRecord={factoryOrderRecord}
                                    isFactoryOrderEdit={Boolean(factoryReleaseRecordId)}
                                     selectedOrder={selectedOrder}
                                    releaseForm={releaseForm}
                                    onProductDeliveryDateChange={handleProductDeliveryDateChange}
                                />
                                <FactoryOrderProductSummary
                                    values={values}
                                    setValues={setValues}
                                    currencyDetail={currencyDetail}
                                    setQuotUserEntry={setQuotUserEntry}
                                    quotUserEntry={quotUserEntry}
                                    factoryOrderRecord={factoryOrderRecord}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}
            <SaveSuccessModel
                show={productionShow}
                createMsg={productionMsg}
                setShow={setProductionShow}
                SuccessDoneClick={() => setProductionShow(false)}
            />
        </div>
    );
};

export default FactoryOrderProduct;
